import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import { FaArrowLeftLong } from "react-icons/fa6";
import Button from "../../../components/common/Button/Button";
import { addBlog } from "../../../api/service/blog.service";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";
import Editor from "../../../components/Editor/Editor";

const AddBlog = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    text: "",
    author: "",
    category: "",
    image: null,
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditorChange = (value) => {
    setFormData((prev) => ({ ...prev, text: value }));
  };

  const handleImageUpload = (file) => {
    setFormData((prev) => ({ ...prev, image: file }));
  };

  const isEditorEmpty = (html) => {
    return !html || html.replace(/<(.|\n)*?>/g, "").trim() === "";
  };

  const handleSubmit = async () => {
// console.log("Form Data on Submit:", formData);
    if (
      !formData.title ||
      !formData.author ||
      !formData.category ||
      isEditorEmpty(formData.text)
    ) {
      showToast.error("Please fill in all required fields.");
      return;
    }

    try {
      setLoading(true);

      const data = new FormData();
      data.append("title", formData.title);
      data.append("text", formData.text);
      data.append("author", formData.author);
      data.append("category", formData.category);

      if (formData.image) {
        data.append("image", formData.image);
      }

      const response = await addBlog(data);

      showToast.success(response?.message || "Blog added successfully!");
      navigate("/blog");
    } catch (error) {
      console.error("Error adding blog:", error);
      showToast.error(
        error?.response?.data?.message || "Failed to create blog!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
   
      <div className="d-flex align-items-center gap-3 mb-3">
        <div
          className="d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => window.history.back()}
        >
          <FaArrowLeftLong />
          <h3 className="mb-0 management-tile ml-2">Blog Management</h3>
        </div>
      </div>

    
      <Row className="g-3">
        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Blog Title</label>
          <FormInput
            placeholder="Enter blog title"
            value={formData.title}
            onChange={(e) => handleChange("title", e.target.value)}
          />
        </Col>

        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Author Name</label>
          <FormInput
            placeholder="Enter author name"
            value={formData.author}
            onChange={(e) => handleChange("author", e.target.value)}
          />
        </Col>

        <Col xs={12}>
          <label className="form-label">Category</label>
          <FormInput
            placeholder="e.g. Industry, Technology, Health"
            value={formData.category}
            onChange={(e) => handleChange("category", e.target.value)}
          />
        </Col>

        <Col xs={12}>
          <label className="form-label">Upload Image / Banner</label>
          <UploadImage onFileSelect={handleImageUpload} multiple={false} />
        </Col>

        <Col xs={12} className="my-3">
          <label className="form-label">Blog Content</label>
          <Editor
            value={formData.text}
            onChange={handleEditorChange}
            placeholder="Write your blog content here..."
            // height="320px"
          />
        </Col>

        <Col xs={12}>
          <Button onClick={handleSubmit} disabled={loading}>
            {loading ? "Submitting..." : "Add Blog"}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default AddBlog;
